export function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}
export function isArray(obj) {
  return Object.prototype.toString.call(obj) === "[object Array]";
}
export function isNull(param) {
  return Object.prototype.toString.call(param) === "[object Null]";
}
export function isUndefined(param) {
  return Object.prototype.toString.call(param) === "[object Undefined]";
}
export function isString(param) {
  return typeof param === "string";
}
export function isMobile() {
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
    navigator.userAgent
  );
}
